import autobind from 'autobind-decorator';
import * as React from 'react';
import { Icons, RoundButton, Text } from '@shared/ui-components';

import { Styled } from './styled';

interface Props {
  minTeamSize: number;
  currentTeamSize: number;
  onTeamSizeChange: (teamSize: number) => void;
}


export class TeamSize extends React.Component<Props> {
  public render(): JSX.Element {
    const { currentTeamSize } = this.props;

    return (
      <Styled.Container>
        <Text fontSize={16} color='mainFont'>Choose your team size</Text>
        <Styled.Counter>
          <RoundButton
            onClick={this.decrement}
            Icon={Icons.MinusBig}
            diameter={50}
          />
          <Styled.CounterText>
            <Text fontSize={16} color='mainFont'>{currentTeamSize} team members</Text>
          </Styled.CounterText>
          <RoundButton
            onClick={this.increment}
            Icon={Icons.PlusBig}
            diameter={50}
          />
        </Styled.Counter>
      </Styled.Container>
    );
  }

  @autobind
  private increment(): void {
    this.props.onTeamSizeChange(this.props.currentTeamSize + 1);
  }

  @autobind
  private decrement(): void {
    if (this.props.currentTeamSize > (this.props.minTeamSize || 1)) {
      this.props.onTeamSizeChange(this.props.currentTeamSize - 1);
    }
  }
}
